import AntPOSLayout from '../AntPOSLayout';
import { unpack, pack } from 'msgpackr';
import stringify from '../../utils/stableStringify';
import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import { Navigate, Route, Routes, useRoutes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Fullscreen from 'react-fullscreen-crossbrowser';
import toast, { Toaster } from 'react-hot-toast';

import cs from '../../utils/const.js';
import AntTime from '../../utils/AntTime';
import AntAuth from '../../utils/AntAuth';
import AntAPI from '../../utils/AntAPI';
import AntLocalStorage from '../../utils/AntLocalStorage';
import AntCondition from '../../utils/AntCondition';
import AntResetPassword from '../AntResetPassword';
import AntToast from '../AntToast';
import AntPrinting from '../AntPrinting';
import AntShiftActionOverlay from '../AntShiftActionOverlay';
import { resolveServiceRoutingQuery } from '../../utils/AntServiceRouting';
import { getClientInstanceId } from '../../utils/AntClientInstance';
import createSocketLifecycle from '../../utils/AntSocketLifecycle';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';

import io from 'socket.io-client';

export default function (props) {
    const appGlobal = AntGlobal();

    const refToast = useRef();
    const refPrinter = useRef();

    const [token, setToken] = React.useState('');
    const [sessionInfo, setSessionInfo] = React.useState(AntAuth.getSessionInfo());

    const [navItems, setNavItems] = React.useState([]);
    const [homeUrl, setHomeUrl] = React.useState('/pos/home');

    const routers = useMemo(() => {
        let ar = appGlobal.posRoutes.filter((r) => AntCondition.isVisible(null, r));
        return ar;
    }, [appGlobal.posRoutes]);

    const [fullScreenable, setFullScreenable] = React.useState(false);

    const initNavItems = useCallback(() => {
        var ar = appGlobal.posNavigation
            .map((i1) => {
                var isVisible = AntCondition.isVisible(null, i1);
                if (!isVisible) return { ...i1, visible: false };

                if (i1.items instanceof Array) {
                    var ar = i1.items.map((i2) => {
                        return { ...i2, visible: AntCondition.isVisible(null, i2) };
                    });
                    var items = [...ar].filter((f) => f && f.visible);

                    return { ...i1, items, visible: items.length > 0 && AntCondition.isVisible(null, i1) };
                }
                return { ...i1, visible: AntCondition.isVisible(null, i1) };
            })
            .filter((f) => f && f.visible);

        if (ar.length > 0) {
            ar = ar.map((item) => {
                if (item.items instanceof Array && item.items.length === 1 && item.distinctable !== false) {
                    return {
                        text: item.items[0].text,
                        path: item.items[0].path,
                        icon: item.icon
                    };
                }
                return item;
            });
        }

        var arNavItems = ar;
        var homeUrl = '/pos/home';

        // if (ar.length > 0) {
        //     var flatAr = ar.map((i) => (i.items instanceof Array ? i.items : i)).flat();
        //     if (flatAr.length > 0 && !flatAr.some((i) => i.path === '/pos/home')) homeUrl = flatAr[0].path;

        //     flatAr = flatAr.filter((i) => i.path !== '/pos/home');
        //     if (flatAr.length === 1) {
        //         homeUrl = flatAr[0].path;
        //         arNavItems = flatAr;
        //     }
        // }
        return {
            homeUrl: homeUrl,
            navItems: arNavItems
        };
    }, [appGlobal.posNavigation]);

    const sessionListeners = useRef([]);
    const registerSessionListener = useCallback((e) => {
        let data = {
            id: String(Math.floor(Math.random() * 1000000)) + String(AntTime.nowUnix()),
            listener: e
        };
        sessionListeners.current.push(data);

        return data;
    }, []);
    const clearSessionListener = useCallback((data) => {
        sessionListeners.current = sessionListeners.current.filter((l) => l.id !== data?.id);
    }, []);

    const onSessionChanged = useCallback(() => {
        for (let i = 0; i < sessionListeners.current.length; i++) {
            const sListener = sessionListeners.current[i];
            if (sListener && sListener.listener) sListener.listener();
        }
        setSessionInfo(AntAuth.getSessionInfo());
    }, []);

    const socketLifecycle = useRef(null);
    const refreshToken = useCallback((done) => {
        AntAuth.refreshToken(false, null, () => {
            socketLifecycle.current?.sync();
            if (typeof done === 'function') done();
        }, (data) => {
            setToken(data);
            onSessionChanged();
        });
    }, [onSessionChanged]);

    const isResetPassword = Boolean(sessionInfo && sessionInfo.password_expired);

    // Trong chế độ POS, nếu user đã Cắt Ca (hoặc chưa Vào Ca) thì BẮT BUỘC hiện Vào Ca,
    // không cho phép thao tác bất kỳ màn nào trong POS cho tới khi Vào Ca thành công.
    // Gating: (1) user được bật manages_work_shift (admin tick trên ACUserAccount), VÀ
    // (2) business bật cả use_Module_AR và use_Module_POS.
    // PIN luôn có (mặc định '111111' nếu user chưa cài).
    const employeeSessionStatus = sessionInfo && sessionInfo.employee_session_status;
    const _managesWorkShift = Number(sessionInfo && sessionInfo.manages_work_shift) === 1;
    const _useModuleAR = Number(AntAuth.getBusSetting && AntAuth.getBusSetting('use_Module_AR')) === 1;
    const _useModulePOS = Number(AntAuth.getBusSetting && AntAuth.getBusSetting('use_Module_POS')) === 1;
    const _shiftFeatureEnabled = _managesWorkShift && _useModuleAR && _useModulePOS;
    const needsForcedCheckin =
        !isResetPassword && sessionInfo && _shiftFeatureEnabled && employeeSessionStatus !== 'InProgress';
    const forcedCheckinSession = needsForcedCheckin
        ? {
              employee_code: sessionInfo.employee_code,
              employee_name: sessionInfo.employee_name,
              store_name: sessionInfo.store_name,
              store_code: sessionInfo.store_code
          }
        : null;
    const handleForcedCheckinDone = useCallback(() => {
        // Sau Vào Ca thành công BE đã refresh token; reload để load session mới.
        try {
            window.location.reload();
        } catch (e) {
            // ignore
        }
    }, []);

    const socket = useRef();
    const socketConnected = useRef(false);
    const hadSocketConnected = useRef(false); // đã từng kết nối → lần 'connect' sau là NỐI LẠI
    const socketDispatch = useRef(null);

    const printingQueue = useRef([]);
    const printedMessages = useRef([]);
    const printingQueueProcessing = useRef(false);
    const printingMessage = useRef(null);

    const socketListeners = useRef([]);

    const isSocketConnected = useCallback(() => {
        return socketConnected.current;
    }, []);

    const registerSocketListener = useCallback((e, strName) => {
        if (strName) socketListeners.current = socketListeners.current.filter((l) => l.name !== strName);

        let data = {
            id: String(Math.floor(Math.random() * 1000000)) + String(AntTime.nowUnix()),
            listener: e,
            name: strName
        };
        socketListeners.current.push(data);

        return data;
    }, []);

    const clearSocketListener = useCallback((data, strName) => {
        if (typeof data === 'string') {
            socketListeners.current = socketListeners.current.filter((l) => l.name !== data);
            return;
        }

        socketListeners.current = socketListeners.current.filter((l) => l.id !== data?.id || l.name !== data?.strName);
    }, []);

    const onSocketConnected = useCallback(() => {
        // console.log('Kết nối thành công!');
        socketConnected.current = true;

        // NỐI LẠI sau khi đứt: tin trong lúc đứt đã mất — phát tin nội bộ cho màn đang mở tự tải lại
        if (hadSocketConnected.current) {
            const payload = { name: 'ANTE_SOCKET', event: 'SOCKET_RECONNECTED', data: { activity: 'SOCKET_RECONNECTED' } };
            for (let i = 0; i < socketListeners.current.length; i++) {
                const sListener = socketListeners.current[i];
                if (sListener && sListener.listener) {
                    try {
                        sListener.listener(payload, sListener.name);
                    } catch (e) {
                        /* listener lỗi không chặn listener khác */
                    }
                }
            }
        }
        hadSocketConnected.current = true;
    }, []);

    const onSocketDisConnected = useCallback(() => {
        socketConnected.current = false;
    }, []);

    const onSocketReceiveANTE_MESSAGE = useCallback((data) => {
        // Dispatch trực tiếp qua ref — KHÔNG đi qua setState: nhiều tin đến cùng nhịp bị React
        // gộp lại chỉ còn tin cuối → mất lệnh in/sự kiện khi dồn dập (giờ cao điểm bếp).
        if (socketDispatch.current) socketDispatch.current(data);
    }, []);

    const connectToSocket = useCallback(() => {
        if (socket.current) return;

        // socket.current?.disconnect();

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        // const header = {
        //     Authorization: 'Bearer ' + token,
        //     'business_short_code': info.business_short_code,
        //     'business_industry': info.business_industry,
        //     'business_sub_industry': info.business_sub_industry
        // };

        delete socket.current;

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        socket.current = io(BaseURL, {
            path: '/socket.io',
            query: {
                token: AntAuth.getSessionSocketToken(),
                BusinessShortCode: info.business_short_code,
                BusinessZoneCode: info.business_zone_code,
                BusinessIndustry: info.business_industry,
                BusinessSubIndustry: info.business_sub_industry,
                clientInstanceId: getClientInstanceId(),
                ...resolveServiceRoutingQuery(info)
            },
            // extraHeaders: header,
            transports: ['websocket'],
            upgrade: false,
            autoConnect: false,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 10000,
            randomizationFactor: 0.5
        });

        // LoggedIn is sent only after the server accepts the socket token.
        socket.current.on('LoggedIn', onSocketConnected);
        socket.current.on('disconnect', onSocketDisConnected);
        socket.current.on('ANTE_MESSAGE', onSocketReceiveANTE_MESSAGE);
        socketLifecycle.current = createSocketLifecycle(socket.current, () => {
            const currentInfo = AntAuth.getSessionInfo() || {};
            return {
                token: AntAuth.getSessionSocketToken(),
                BusinessShortCode: currentInfo.business_short_code,
                BusinessZoneCode: currentInfo.business_zone_code,
                BusinessIndustry: currentInfo.business_industry,
                BusinessSubIndustry: currentInfo.business_sub_industry,
                // wake() gán lại query bằng hàm này trước mỗi lần nối: thiếu mã tab thì BE không nhận ra tab vừa thao tác.
                clientInstanceId: getClientInstanceId(),
                ...resolveServiceRoutingQuery(currentInfo)
            };
        }, refreshToken);
        socketLifecycle.current.wake();
    }, [onSocketConnected, onSocketDisConnected, onSocketReceiveANTE_MESSAGE, refreshToken]);

    const onShowToast = useCallback((data, onClicked, opts) => {
        if (refToast.current?.showToast) return refToast.current?.showToast(data, onClicked, opts);
    }, []);

    const getRoutes = useCallback(() => {
        return routers;
    }, [routers]);

    const getHomeURL = useCallback(() => {
        return homeUrl;
    }, [homeUrl]);

    const [sessionContext, setSessionContext] = React.useState({
        onSessionChanged: onSessionChanged,
        isSocketConnected: isSocketConnected,
        registerSessionListener: registerSessionListener,
        registerSocketListener: registerSocketListener,
        clearSessionListener: clearSessionListener,
        clearSocketListener: clearSocketListener,
        showToast: onShowToast,
        getRoutes: getRoutes,
        getHomeURL: getHomeURL
    });

    const onActionPrint = useCallback((msg) => {
        return new Promise(async (resolve) => {
            if (refPrinter.current && msg?.message?.html) {
                let isExisted = printedMessages.current.some((m) => {
                    let diffSeconds = AntTime.diffSecondToNow(m.at);
                    return stringify(m.message) === stringify(msg.message) && diffSeconds < 10;
                });

                if (!isExisted) {
                    printingMessage.current = msg;
                    refPrinter.current.load({ html: msg?.message?.html, height: msg?.message?.htmlHeight });
                }
                resolve(true);
            } else if (refPrinter.current && msg.cnfPrint.printUrl && msg.cnfPrint.module && msg.cnfPrint.table) {
                var body = {};
                if (msg.cnfPrint.repostFields instanceof Array) {
                    for (let i = 0; i < msg.cnfPrint.repostFields.length; i++) {
                        const cnfField = msg.cnfPrint.repostFields[i];
                        if (typeof cnfField === 'string') body[cnfField] = msg.message[cnfField];
                        else body[cnfField.alias] = msg.message[cnfField.dateField];
                    }
                } else {
                    body = {
                        code: msg.message.order_code
                    };
                }

                const mainAPI = new AntAPI(msg.cnfPrint.module, msg.cnfPrint.table);
                mainAPI.post(msg.cnfPrint.printUrl, body, async (resData) => {
                    if (resData.data?.cancel) {
                        resolve();
                        return;
                    }

                    while (printingMessage.current) {
                        await AntTime.sleep(1000);
                    }

                    let isExisted = printedMessages.current.some((m) => {
                        let diffSeconds = AntTime.diffSecondToNow(m.at);
                        return stringify(m.message) === stringify(msg.message) && diffSeconds < 10;
                    });

                    if (!isExisted) {
                        printingMessage.current = msg;
                        refPrinter.current.load(resData.data);
                    }
                    resolve(true);
                });
            } else resolve();
        });
    }, []);

    const handlePrint = useReactToPrint({
        content: () => {
            return refPrinter.current;
        },
        onAfterPrint: () => {
            printedMessages.current.push(printingMessage.current);
            printingMessage.current = null;
            // console.log('In xong!');
            // alert('Đã in xong!');
        }
    });

    const processPrintingQueue = useCallback(async () => {
        while (printingQueueProcessing.current) {
            await AntTime.sleep(1000);
        }

        printingQueueProcessing.current = true;
        while (printingQueue.current.length > 0) {
            const msg = printingQueue.current[0];
            await onActionPrint(msg);
            printingQueue.current.shift();
        }
        printingQueueProcessing.current = false;
    }, [onActionPrint]);

    // Gán socketDispatch.current mỗi render để luôn có closure mới nhất — xử lý TỪNG tin
    // ngay khi đến (pattern như AntMainArea), không dồn qua state.
    socketDispatch.current = (data) => {
        if (!data) return;

        if (data.event === 'RefreshToken') {
            refreshToken();
            return;
        }

        const currentStoreCode = AntAuth.getSessionInfo('store_code');
        const eventStoreCode = data.store_code || data.data?.store_code;
        if (eventStoreCode && currentStoreCode && currentStoreCode !== 'ALL_STORES' && String(eventStoreCode) !== String(currentStoreCode)) return;

        if (data.event === 'RemotePrint') {
            if (!eventStoreCode || !currentStoreCode || currentStoreCode === 'ALL_STORES' || String(eventStoreCode) !== String(currentStoreCode)) return;
            let cnfPrint = appGlobal.backgroundPrinters?.find((p) => p.activity === data.activity);
            if (cnfPrint) {
                let isExisted = printingQueue.current.some((m) => {
                    let diffSeconds = AntTime.diffSecondToNow(m.at);
                    return stringify(m.message) === stringify(data) && diffSeconds < 5;
                });
                if (!isExisted) {
                    printingQueue.current.push({
                        at: AntTime.nowUnix(),
                        message: data,
                        cnfPrint: cnfPrint
                    });
                    processPrintingQueue();
                }
                return;
            }
        }

        for (let i = 0; i < socketListeners.current.length; i++) {
            const sListener = socketListeners.current[i];
            if (sListener && sListener.listener) {
                let handled = sListener.listener(data, sListener.name);
                if (handled) break;
            }
        }
    };

    useEffect(() => {
        var obj = initNavItems();
        if (obj.navItems instanceof Array && obj.navItems.length === 1) setHomeUrl(obj.navItems[0].path);
        else setHomeUrl(obj.homeUrl);
        setNavItems(obj.navItems);
    }, [initNavItems]);

    useEffect(() => {
        setSessionInfo(AntAuth.getSessionInfo());

        AntLocalStorage.clearGlobalExpiredKeys();
    }, [token]);

    useEffect(() => {
        if (sessionInfo)
            setSessionContext({
                ...JSON.parse(stringify(sessionInfo)),
                onSessionChanged: onSessionChanged,
                isSocketConnected: isSocketConnected,
                registerSessionListener: registerSessionListener,
                registerSocketListener: registerSocketListener,
                clearSessionListener: clearSessionListener,
                clearSocketListener: clearSocketListener,
                showToast: onShowToast,
                getRoutes: getRoutes,
                getHomeURL: getHomeURL
            });

        var obj = initNavItems();
        if (obj.navItems instanceof Array && obj.navItems.length === 1) setHomeUrl(obj.navItems[0].path);
        else setHomeUrl(obj.homeUrl);
        setNavItems(obj.navItems);
    }, [
        sessionInfo,
        initNavItems,
        onShowToast,
        onSessionChanged,
        isSocketConnected,
        registerSessionListener,
        clearSessionListener,
        registerSocketListener,
        clearSocketListener,
        getRoutes,
        getHomeURL
    ]);

    useEffect(() => {
        refreshToken();

        // Tab ẩn: bỏ nhịp làm mới phiên (mỗi tab tự gọi; người dùng mở nhiều tab thì tab nền gọi thừa). Tab hiện lại thì làm
        // mới ngay nếu đã quá 1 phút — giới hạn giờ truy cập vẫn có hiệu lực khi người dùng quay lại.
        let lastRefreshAt = Date.now();
        const refreshIfVisible = () => {
            if (typeof document !== 'undefined' && document.hidden) return;
            lastRefreshAt = Date.now();
            refreshToken();
        };
        const handleVisibility = () => {
            if (!document.hidden && Date.now() - lastRefreshAt >= 1000 * 60) refreshIfVisible();
        };
        document.addEventListener('visibilitychange', handleVisibility);
        const interval = setInterval(() => {
            refreshIfVisible();
            if (!socket.current?.connected) {
                socket.current?.connect();
            }
        }, 1000 * 60 * 1);

        document
            .getElementById('posFullScreenID')
            .requestFullscreen()
            .then(
                () => {
                    // console.log('fullscreen');
                    setFullScreenable(true);
                },
                () => {
                    // console.warn('no fullscreen');
                    setFullScreenable(false);
                }
            );
        connectToSocket();

        const handleWakeup = () => {
            socketLifecycle.current?.wake();
        };

        window.addEventListener('focus', handleWakeup);

        // Đóng tab/reload: chủ động ngắt để server dọn ngay thay vì chờ ping-timeout
        const handleBeforeUnload = () => {
            try {
                socketLifecycle.current?.dispose();
            } catch (e) {
                /* silent */
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            socketLifecycle.current?.dispose();
            socketLifecycle.current = null;
            socket.current = null;
            socketConnected.current = false;
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibility);
            window.removeEventListener('focus', handleWakeup);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <BrowserRouter>
            <AntSessionContext.Provider value={sessionContext}>
                <Fullscreen enabled={fullScreenable}>
                    <div id={'posFullScreenID'} style={{ width: '100%', height: '100%', display: 'flex' }}>
                        {isResetPassword && (
                            <Routes>
                                <Route path="*" Component={AntResetPassword} />
                            </Routes>
                        )}
                        {!isResetPassword && (
                            <AntPOSLayout navigateItems={navItems}>
                                <Routes>
                                    {routers.map((item) => (
                                        <Route key={item.path} path={item.path} Component={item.component} element={item.element} />
                                    ))}
                                    <Route path="*" element={<Navigate to={homeUrl} replace />} />
                                </Routes>
                            </AntPOSLayout>
                        )}
                        {needsForcedCheckin && (
                            <AntShiftActionOverlay
                                mode="checkin"
                                forced={true}
                                session={forcedCheckinSession}
                                onDone={handleForcedCheckinDone}
                            />
                        )}
                        {!isResetPassword && <AntToast ref={refToast} />}
                        {!isResetPassword && (
                            <div style={{ display: 'none' }}>
                                <AntPrinting ref={refPrinter} appGlobal={appGlobal} onReady={handlePrint} />
                            </div>
                        )}
                    </div>
                </Fullscreen>
            </AntSessionContext.Provider>
        </BrowserRouter>
    );
}
